/* Pasanka theme - vanilla JS (no build step required) */
(function () {
  'use strict';

  var T = window.theme || { routes: {}, strings: {} };
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var escapeHtml = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var json = function (url, opts) {
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (data) { return { ok: r.ok, status: r.status, data: data }; });
    });
  };

  /* ------------------------------------------------------------------ header */
  function initHeader() {
    var header = $('[data-site-header]');
    if (!header || header.dataset.ready) return;
    header.dataset.ready = '1';
    var bar = $('.hdr-bar', header);
    var onScroll = function () {
      if (window.scrollY > 24) bar.setAttribute('data-scrolled', ''); else bar.removeAttribute('data-scrolled');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    // mobile menu
    var menuBtn = $('[data-menu-toggle]', header);
    var menu = $('[data-mobile-menu]', header);
    if (menuBtn && menu) {
      menuBtn.addEventListener('click', function () {
        var open = menu.hasAttribute('hidden');
        menu.toggleAttribute('hidden', !open);
        menuBtn.setAttribute('aria-expanded', String(open));
        $('[data-menu-icon-open]', header).toggleAttribute('hidden', open);
        $('[data-menu-icon-close]', header).toggleAttribute('hidden', !open);
      });
    }

    // phone menu: the search icon closes the menu and opens the header search
    var mobSearch = $('[data-mobile-search]', header);
    if (mobSearch && menuBtn && menu) {
      mobSearch.addEventListener('click', function () {
        if (!menu.hasAttribute('hidden')) menuBtn.click();
        var t = $('[data-search-toggle]', header);
        if (t) t.click();
      });
    }

    // account dropdown
    var accBtn = $('[data-account-toggle]', header);
    var accPanel = $('[data-account-panel]', header);
    if (accBtn && accPanel) {
      accBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = accPanel.hasAttribute('hidden');
        accPanel.toggleAttribute('hidden', !open);
        accBtn.setAttribute('aria-expanded', String(open));
      });
      document.addEventListener('click', function (e) {
        if (!accPanel.contains(e.target)) { accPanel.setAttribute('hidden', ''); accBtn.setAttribute('aria-expanded', 'false'); }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') accPanel.setAttribute('hidden', ''); });
    }

    // search with live suggestions
    var searchBtn = $('[data-search-toggle]', header);
    var panel = $('[data-search-panel]', header);
    var input = $('[data-search-input]', header);
    var results = $('[data-search-results]', header);
    var actions = $('[data-header-actions]', header);
    var timer;
    // The search field replaces the header icons in the bar while it is open.
    function closeSearch() {
      panel.setAttribute('hidden', '');
      if (actions) actions.removeAttribute('hidden');
      searchBtn.setAttribute('aria-expanded', 'false');
      input.value = '';
      results.setAttribute('hidden', '');
      results.innerHTML = '';
    }
    if (searchBtn && panel && input) {
      searchBtn.addEventListener('click', function () {
        panel.removeAttribute('hidden');
        if (actions) actions.setAttribute('hidden', '');
        searchBtn.setAttribute('aria-expanded', 'true');
        input.focus();
      });
      $('[data-search-close]', header).addEventListener('click', closeSearch);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hasAttribute('hidden')) closeSearch(); });
      document.addEventListener('click', function (e) {
        if (!panel.hasAttribute('hidden') && !panel.contains(e.target) && !searchBtn.contains(e.target)) closeSearch();
      });
      input.addEventListener('input', function () {
        clearTimeout(timer);
        var q = input.value.trim();
        if (!q) { results.setAttribute('hidden', ''); results.innerHTML = ''; return; }
        timer = setTimeout(function () {
          var url = (T.routes.searchSuggest || '/search/suggest') + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8';
          json(url).then(function (res) {
            var products = (res.data && res.data.resources && res.data.resources.results && res.data.resources.results.products) || [];
            results.removeAttribute('hidden');
            if (!products.length) {
              results.innerHTML = '<div class="px-4 py-6 text-center text-sm text-forest/60">' + escapeHtml(T.strings.noResults) + ' “' + escapeHtml(q) + '”.</div>';
              return;
            }
            results.innerHTML = '<ul>' + products.map(function (p) {
              var img = T.defaultProductImage || '';
              return '<li><a href="' + escapeHtml(p.url) + '" class="flex items-center gap-3 rounded-2xl px-3 py-2 hover:bg-forest/5">' +
                (img ? '<img src="' + escapeHtml(img) + '" alt="" class="h-11 w-11 rounded-xl object-cover shrink-0">' : '<span class="h-11 w-11 rounded-xl bg-soft shrink-0"></span>') +
                '<span class="min-w-0"><span class="block text-sm truncate">' + escapeHtml(p.title) + '</span>' +
                '<span class="block text-xs text-forest/55">' + escapeHtml(p.type || p.product_type || '') + '</span></span></a></li>';
            }).join('') + '</ul><a href="' + T.routes.search + '?type=product&q=' + encodeURIComponent(q) + '" class="mt-1 block w-full rounded-2xl px-4 py-3 text-sm text-center underline underline-offset-4 hover:bg-forest/5">' + escapeHtml(T.strings.viewAll) + '</a>';
          }).catch(function () {});
        }, 220);
      });
    }
  }

  /* ------------------------------------------------------------ scroll reveal */
  var revealObserver = null;
  function initReveal(root) {
    var els = $$('.reveal:not(.is-in)', root);
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); revealObserver.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -80px 0px', threshold: 0.01 });
    }
    els.forEach(function (el) { revealObserver.observe(el); });
  }

  /* -------------------------------------------------------------------- cart */
  var drawer, overlay;
  function drawerEls() {
    drawer = $('[data-cart-drawer]');
    overlay = $('[data-cart-overlay]');
  }
  function openDrawer() {
    drawerEls();
    if (!drawer) return false;
    drawer.classList.remove('translate-x-full', 'invisible');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.removeAttribute('hidden');
    document.documentElement.style.overflow = 'hidden';
    return true;
  }
  function closeDrawer() {
    drawerEls();
    if (!drawer) return;
    drawer.classList.add('translate-x-full');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.setAttribute('hidden', '');
    document.documentElement.style.overflow = '';
    setTimeout(function () { if (drawer.getAttribute('aria-hidden') === 'true') drawer.classList.add('invisible'); }, 400);
  }
  function setCartCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.toggleAttribute('hidden', !n);
    });
  }
  function refreshCart() {
    return Promise.all([
      fetch(T.routes.cartJson, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }),
      fetch(window.location.pathname + '?sections=cart-drawer').then(function (r) { return r.json(); })
    ]).then(function (res) {
      setCartCount(res[0].item_count);
      var html = res[1] && res[1]['cart-drawer'];
      if (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('#cart-drawer-inner', doc);
        var current = $('#cart-drawer-inner');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      }
      return res[0];
    });
  }
  function addToCart(items, onError) {
    return json(T.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (!res.ok) {
        var msg = (res.data && (res.data.description || res.data.message)) || T.strings.error;
        if (onError) onError(msg);
        return false;
      }
      if (T.cartType === 'page' || !$('[data-cart-drawer]')) { window.location.href = T.routes.cart; return true; }
      return refreshCart().then(function () { openDrawer(); return true; });
    }).catch(function () { if (onError) onError(T.strings.error); return false; });
  }
  function changeCart(body) {
    return json(T.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  // Cart page: change a quantity or remove a line and swap in the fresh cart without reloading the page.
  var cartPageBusy = false;
  function updateCartPage(body) {
    var cur = $('.system-cart');
    if (!cur) { window.location.reload(); return; }
    if (cartPageBusy) return;
    cartPageBusy = true;
    cur.style.transition = 'opacity .2s ease';
    cur.style.opacity = '.55';
    cur.style.pointerEvents = 'none';
    var note = $('#cart-note', cur);
    var noteValue = note ? note.value : null;
    changeCart(body).then(function () {
      return fetch(window.location.pathname, { headers: { Accept: 'text/html' } }).then(function (r) { return r.text(); });
    }).then(function (html) {
      var fresh = $('.system-cart', new DOMParser().parseFromString(html, 'text/html'));
      if (!fresh) { window.location.reload(); return; }
      cur.innerHTML = fresh.innerHTML;
      var newNote = $('#cart-note', cur);
      if (newNote && noteValue !== null) newNote.value = noteValue;
      initReveal(cur);
      return fetch(T.routes.cartJson, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { setCartCount(c.item_count); });
    }).catch(function () { window.location.reload(); }).then(function () {
      cartPageBusy = false;
      cur.style.opacity = '';
      cur.style.pointerEvents = '';
    });
  }

  // Shop (phones): the Price chip opens a bottom sheet with quick ranges and min/max fields
  function initPriceSheet() {
    var sheet = $('[data-price-sheet]');
    if (!sheet) return;
    var minI = $('[data-price-min]', sheet), maxI = $('[data-price-max]', sheet);
    var presets = $$('[data-preset]', sheet);
    var sync = function () {
      presets.forEach(function (b) {
        b.classList.toggle('is-active', (b.dataset.min || '') === (minI.value || '') && (b.dataset.max || '') === (maxI.value || '') && (minI.value !== '' || maxI.value !== ''));
      });
    };
    var open = function () { sheet.removeAttribute('hidden'); document.documentElement.style.overflow = 'hidden'; sync(); };
    var close = function () { sheet.setAttribute('hidden', ''); document.documentElement.style.overflow = ''; };
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-price-open]')) { open(); return; }
      if (e.target.closest('[data-price-close]')) { close(); return; }
      var p = e.target.closest('[data-preset]');
      if (p && sheet.contains(p)) { minI.value = p.dataset.min || ''; maxI.value = p.dataset.max || ''; sync(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sheet.hasAttribute('hidden')) close(); });
    [minI, maxI].forEach(function (i) { i.addEventListener('input', sync); });
  }

  function initCart() {
    // typing a quantity on the cart page updates in place too (Enter must not submit the whole form)
    document.addEventListener('change', function (e) {
      var inp = e.target.closest && e.target.closest('.system-cart input[name="updates[]"]');
      if (!inp) return;
      var all = $$('.system-cart input[name="updates[]"]');
      var qty = Math.max(0, parseInt(inp.value, 10) || 0);
      updateCartPage({ line: all.indexOf(inp) + 1, quantity: qty });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches && e.target.matches('.system-cart input[name="updates[]"]')) {
        e.preventDefault();
        e.target.blur();
      }
    });
    document.addEventListener('click', function (e) {
      var t = e.target;
      var toggle = t.closest('[data-cart-toggle]');
      if (toggle && T.cartType !== 'page' && $('[data-cart-drawer]') && window.location.pathname !== T.routes.cart) {
        e.preventDefault();
        openDrawer();
        return;
      }
      if (t.closest('[data-cart-close]') || t.closest('[data-cart-overlay]')) { closeDrawer(); return; }

      var qtyBtn = t.closest('[data-cart-qty]');
      if (qtyBtn) {
        e.preventDefault();
        qtyBtn.disabled = true;
        changeCart({ id: qtyBtn.dataset.key, quantity: parseInt(qtyBtn.dataset.qty, 10) }).then(refreshCart).catch(function () {}).then(function () { qtyBtn.disabled = false; });
        return;
      }

      var lineBtn = t.closest('[data-cart-line-qty]');
      if (lineBtn) {
        e.preventDefault();
        lineBtn.disabled = true;
        updateCartPage({ line: parseInt(lineBtn.dataset.line, 10), quantity: parseInt(lineBtn.dataset.qty, 10) });
        return;
      }

      var add = t.closest('[data-add-to-cart]');
      if (add) {
        e.preventDefault();
        var card = add.closest('[data-product-card]');
        var msg = card && $('[data-card-message]', card);
        if (msg) msg.setAttribute('hidden', '');
        add.disabled = true;
        addToCart([{ id: parseInt(add.dataset.variantId, 10), quantity: 1 }], function (m) {
          if (msg) { msg.textContent = m; msg.removeAttribute('hidden'); } else { window.alert(m); }
        }).then(function () { add.disabled = add.hasAttribute('data-sold-out'); });
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

    // variant select on product cards
    document.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-card-variant]');
      if (!sel) return;
      var card = sel.closest('[data-product-card]');
      var opt = sel.options[sel.selectedIndex];
      var btn = $('[data-add-to-cart]', card);
      var price = $('[data-card-price]', card);
      var available = opt.dataset.available === 'true';
      btn.dataset.variantId = sel.value;
      btn.disabled = !available;
      if (available) btn.removeAttribute('data-sold-out'); else btn.setAttribute('data-sold-out', '');
      btn.textContent = available ? T.strings.addToCart : T.strings.soldOut;
      if (price) price.textContent = opt.dataset.price;
    });
  }

  /* ---------------------------------------------------------------- wishlist */
  var WL_KEY = 'pasanka_wishlist';
  function wlGet() { try { return JSON.parse(localStorage.getItem(WL_KEY) || '[]'); } catch (e) { return []; } }
  function wlSet(list) { try { localStorage.setItem(WL_KEY, JSON.stringify(list)); } catch (e) {} }
  function wlSync(root) {
    var list = wlGet();
    $$('[data-wishlist-toggle]', root).forEach(function (b) {
      b.setAttribute('aria-pressed', String(list.indexOf(b.dataset.wishlistToggle) > -1));
    });
    $$('[data-wishlist-count]').forEach(function (c) {
      c.textContent = list.length;
      c.toggleAttribute('hidden', !list.length);
    });
  }
  function initWishlist() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();
      var h = btn.dataset.wishlistToggle;
      var list = wlGet();
      var i = list.indexOf(h);
      if (i > -1) list.splice(i, 1); else list.push(h);
      wlSet(list);
      wlSync(document);
      document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { handle: h, saved: i === -1 } }));
    });
    document.addEventListener('wishlist:change', function (e) {
      var page = $('[data-wishlist-grid]');
      if (!page || e.detail.saved) return;
      var card = $('[data-wishlist-item="' + e.detail.handle + '"]', page);
      if (card) card.remove();
      if (!$('[data-wishlist-item]', page)) { page.setAttribute('hidden', ''); $('[data-wishlist-empty]').removeAttribute('hidden'); }
    });
    window.addEventListener('storage', function () { wlSync(document); });
  }
  function initWishlistPage(root) {
    var grid = $('[data-wishlist-grid]', root);
    if (!grid || grid.dataset.loaded) return;
    grid.dataset.loaded = '1';
    var empty = $('[data-wishlist-empty]', root);
    var loading = $('[data-wishlist-loading]', root);
    var list = wlGet();
    if (!list.length) { if (loading) loading.setAttribute('hidden', ''); empty.removeAttribute('hidden'); return; }
    Promise.all(list.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '?view=card').then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (cards) {
      if (loading) loading.setAttribute('hidden', '');
      var any = false;
      cards.forEach(function (html, i) {
        if (!html.trim()) return;
        any = true;
        var wrap = document.createElement('div');
        wrap.className = 'rounded-2xl bg-white overflow-hidden';
        wrap.setAttribute('data-wishlist-item', list[i]);
        wrap.innerHTML = html;
        grid.appendChild(wrap);
      });
      if (any) { grid.removeAttribute('hidden'); wlSync(grid); } else { empty.removeAttribute('hidden'); }
    });
  }

  /* ----------------------------------------------------------------- sliders */
  function initSliders(root) {
    $$('[data-slider]', root).forEach(function (el) {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      var slides = $$('[data-slide]', el);
      if (!slides.length) return;
      var i = parseInt(el.dataset.start || '0', 10) || 0;
      var paused = false;
      var interval = parseInt(el.dataset.interval || '6000', 10);
      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) {
          s.classList.toggle('is-active', k === i);
          s.setAttribute('aria-hidden', String(k !== i));
        });
      }
      show(i);
      var prev = $('[data-slider-prev]', el), next = $('[data-slider-next]', el);
      if (prev) prev.addEventListener('click', function () { show(i - 1); });
      if (next) next.addEventListener('click', function () { show(i + 1); });
      el.addEventListener('mouseenter', function () { paused = true; });
      el.addEventListener('mouseleave', function () { paused = false; });
      if (slides.length > 1) setInterval(function () { if (!paused && document.visibilityState === 'visible') show(i + 1); }, interval);
    });
  }

  function initCarousels(root) {
    $$('[data-carousel]', root).forEach(function (el) {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      var track = $('[data-carousel-track]', el);
      var items = $$('[data-carousel-item]', el);
      var dots = $('[data-carousel-dots]', el);
      var prev = $('[data-carousel-prev]', el), next = $('[data-carousel-next]', el);
      var index = 0, visible = 4, paused = false, max = 0;
      function layout() {
        visible = window.innerWidth >= 1024 ? 4 : window.innerWidth >= 640 ? 2 : (parseInt(el.dataset.visibleMobile, 10) || 1);
        max = Math.max(0, items.length - visible);
        index = Math.min(index, max);
        items.forEach(function (it) { it.style.width = (100 / visible) + '%'; });
        [prev, next, dots].forEach(function (c) { if (c) c.toggleAttribute('hidden', max === 0); });
        if (dots) {
          dots.innerHTML = '';
          for (var k = 0; k <= max; k++) {
            var d = document.createElement('button');
            d.type = 'button';
            d.setAttribute('aria-label', 'Go to slide ' + (k + 1));
            d.dataset.dot = k;
            dots.appendChild(d);
          }
        }
        render();
      }
      function render() {
        track.style.transform = 'translateX(-' + (index * 100 / visible) + '%)';
        if (dots) $$('button', dots).forEach(function (d, k) {
          d.className = 'h-2 rounded-full transition-all ' + (k === index ? 'w-6 bg-forest' : 'w-2 bg-forest/25');
          d.setAttribute('aria-current', String(k === index));
        });
      }
      function step(d) { index = index + d > max ? 0 : index + d < 0 ? max : index + d; render(); }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      if (dots) dots.addEventListener('click', function (e) { var b = e.target.closest('[data-dot]'); if (b) { index = parseInt(b.dataset.dot, 10); render(); } });
      el.addEventListener('mouseenter', function () { paused = true; });
      el.addEventListener('mouseleave', function () { paused = false; });
      el.addEventListener('focusin', function () { paused = true; });
      el.addEventListener('focusout', function () { paused = false; });
      window.addEventListener('resize', layout);
      setInterval(function () { if (max > 0 && !paused) step(1); }, 3000);
      layout();
    });
  }

  /* ----------------------------------------------------------- product page */
  function initProduct(root) {
    $$('[data-product-form]', root).forEach(function (form) {
      if (form.dataset.ready) return;
      form.dataset.ready = '1';
      var dataEl = $('[data-product-json]', form.closest('[data-product-section]') || document);
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var idInput = $('input[name="id"]', form);
      var qty = $('input[name="quantity"]', form);
      var addBtn = $('[data-product-add]', form);
      var priceEl = $('[data-price]', form.closest('[data-product-section]'));
      var compareEl = $('[data-compare-price]', form.closest('[data-product-section]'));
      var skuEl = $('[data-sku]', form.closest('[data-product-section]'));
      var stockEl = $('[data-stock]', form.closest('[data-product-section]'));
      var msg = $('[data-product-message]', form);

      function current() {
        // Collect by option index so radios and selects can be mixed.
        var byIndex = [];
        $$('[data-option-input]', form).forEach(function (i) {
          if ((i.type === 'radio' && i.checked) || i.tagName === 'SELECT') byIndex[parseInt(i.dataset.optionIndex, 10)] = i.value;
        });
        return variants.filter(function (v) {
          return v.options.every(function (o, k) { return byIndex[k] === undefined || byIndex[k] === o; });
        })[0];
      }
      function stockText(v) {
        if (!v.available) return '<span class="text-red-600">' + T.strings.outOfStock + '</span>';
        if (v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= 5) return '<span class="text-amber-700">' + T.strings.onlyLeft.replace('{n}', v.inventory_quantity) + '</span>';
        return '<span class="text-green-700">' + T.strings.inStock + '</span>';
      }
      function update() {
        var v = current();
        if (!v) { addBtn.disabled = true; addBtn.textContent = T.strings.soldOut; return; }
        idInput.value = v.id;
        if (priceEl) priceEl.textContent = v.price_formatted;
        if (compareEl) {
          compareEl.textContent = v.compare_formatted || '';
          compareEl.toggleAttribute('hidden', !v.compare_formatted);
        }
        if (skuEl) skuEl.textContent = v.sku ? 'SKU ' + v.sku : '';
        if (stockEl) stockEl.innerHTML = stockText(v);
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? T.strings.addToCart : T.strings.soldOut;
        if (v.featured_media_id) {
          var thumb = $('[data-media-id="' + v.featured_media_id + '"]', document);
          if (thumb) thumb.click();
        }
        if (window.history && history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState({}, '', u.toString());
        }
      }
      form.addEventListener('change', function (e) { if (e.target.closest('[data-option-input]')) { if (msg) msg.setAttribute('hidden', ''); update(); } });

      var minus = $('[data-qty-minus]', form), plus = $('[data-qty-plus]', form);
      if (minus) minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      if (plus) plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
      qty.addEventListener('change', function () { qty.value = Math.max(1, Math.floor(Number(qty.value)) || 1); });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addBtn.disabled = true;
        if (msg) msg.setAttribute('hidden', '');
        addToCart([{ id: parseInt(idInput.value, 10), quantity: parseInt(qty.value, 10) || 1 }], function (m) {
          if (msg) { msg.textContent = m; msg.removeAttribute('hidden'); }
        }).then(function () { update(); });
      });
    });

    // gallery thumbnails
    $$('[data-gallery]', root).forEach(function (g) {
      if (g.dataset.ready) return;
      g.dataset.ready = '1';
      var main = $('[data-gallery-main]', g);
      g.addEventListener('click', function (e) {
        var t = e.target.closest('[data-thumb]');
        if (!t) return;
        main.src = t.dataset.full;
        main.srcset = '';
        main.alt = t.dataset.alt || '';
        $$('[data-thumb]', g).forEach(function (x) { x.classList.toggle('ring-2', x === t); x.classList.toggle('ring-forest', x === t); });
      });
    });
  }

  /* ------------------------------------------------------------ select with thumbnails */
  // Replaces a native <select> with a button + listbox that can show a thumbnail per option
  // (option[data-image]). The native select stays in the DOM, so form submit and change events still work.
  function enhanceSelect(sel) {
    if (sel._pasRefresh) return;
    var wrap = document.createElement('div');
    wrap.className = 'pas-select';
    sel.parentNode.insertBefore(wrap, sel);
    wrap.appendChild(sel);
    sel.classList.add('pas-select-native');
    sel.tabIndex = -1;
    sel.setAttribute('aria-hidden', 'true');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'line-input pas-select-btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    var lab = sel.id ? document.querySelector('label[for="' + sel.id + '"]') : null;
    if (lab) { lab.id = lab.id || sel.id + '-label'; btn.setAttribute('aria-labelledby', lab.id); }
    var list = document.createElement('ul');
    list.className = 'pas-select-list';
    list.setAttribute('role', 'listbox');
    list.hidden = true;
    wrap.appendChild(btn);
    wrap.appendChild(list);

    var thumb = function (o, cls) {
      return o && o.dataset.image ? '<img src="' + escapeHtml(o.dataset.image) + '" alt="" class="' + cls + '">' : '';
    };
    function close() { list.hidden = true; btn.setAttribute('aria-expanded', 'false'); }
    function open() {
      if (btn.disabled) return;
      list.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      var cur = $('[aria-selected="true"]', list) || $('li', list);
      if (cur) cur.focus();
    }
    function choose(value) {
      sel.value = value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      render();
      close();
      btn.focus();
    }
    function render() {
      list.innerHTML = '';
      Array.prototype.forEach.call(sel.options, function (o) {
        if (!o.value) return;
        var li = document.createElement('li');
        li.setAttribute('role', 'option');
        li.tabIndex = -1;
        li.dataset.value = o.value;
        li.setAttribute('aria-selected', o.value === sel.value ? 'true' : 'false');
        li.innerHTML = thumb(o, 'pas-select-thumb pas-select-thumb-lg') + '<span>' + escapeHtml(o.textContent) + '</span>';
        list.appendChild(li);
      });
      var cur = sel.options[sel.selectedIndex];
      var has = !!(cur && cur.value);
      btn.innerHTML = (has ? thumb(cur, 'pas-select-thumb') : '') +
        '<span class="pas-select-label' + (has ? '' : ' is-placeholder') + '">' + escapeHtml(cur ? cur.textContent : '') + '</span>' +
        '<svg class="pas-select-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';
      btn.disabled = sel.disabled;
      if (btn.disabled) close();
    }
    sel._pasRefresh = render;

    btn.addEventListener('click', function () { list.hidden ? open() : close(); });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); open(); }
    });
    list.addEventListener('click', function (e) {
      var li = e.target.closest('li');
      if (li) choose(li.dataset.value);
    });
    list.addEventListener('keydown', function (e) {
      var li = e.target.closest('li');
      if (!li) return;
      if (e.key === 'ArrowDown' && li.nextElementSibling) { e.preventDefault(); li.nextElementSibling.focus(); }
      else if (e.key === 'ArrowUp' && li.previousElementSibling) { e.preventDefault(); li.previousElementSibling.focus(); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(li.dataset.value); }
      else if (e.key === 'Escape') { close(); btn.focus(); }
      else if (e.key === 'Tab') { close(); }
    });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
    render();
  }

  /* ------------------------------------------------------------ product details popup */
  // Modal used by the contact form's product overview card. p = catalogue entry, category = its category title.
  function openProductModal(p, category, trigger) {
    var rows = function (s) { return String(s || '').split(/\r?\n|~/).map(function (r) { return r.trim(); }).filter(Boolean); };
    var h2 = function (t) { return '<h3 class="pas-modal-h">' + t + '</h3>'; };
    var html = '';
    if (p.image) html += '<div class="pas-modal-media"><img src="' + escapeHtml(p.image) + '" alt=""></div>';
    html += '<div class="pas-modal-eyebrow">' + escapeHtml(category) + '</div>' +
      '<h2 class="pas-modal-title" id="pas-modal-title">' + escapeHtml(p.title) + '</h2>' +
      '<div class="pas-modal-price"><span>' + escapeHtml(p.price || '') + '</span>' +
      '<span class="' + (p.available ? 'is-in' : 'is-out') + '">' + (p.available ? 'In stock' : 'Out of stock') + '</span>' +
      (p.sku ? '<span class="pas-modal-sku">SKU ' + escapeHtml(p.sku) + '</span>' : '') + '</div>' +
      // descHtml is the store's own product description (Shopify admin rich text), same as the product page
      '<div class="pas-modal-desc rte">' + (p.descHtml || escapeHtml(p.desc || p.note || '')) + '</div>';
    if (p.variants && p.variants.length) {
      html += h2('Pack sizes &amp; prices') + '<table class="pas-modal-table"><tbody>' +
        p.variants.map(function (v) {
          return '<tr><td>' + escapeHtml(v.title) + (v.available ? '' : ' <em class="pas-modal-soldout">(sold out)</em>') +
            '</td><td>' + escapeHtml(v.price) + '</td></tr>';
        }).join('') + '</tbody></table>';
    }
    if (p.ingredients) {
      html += h2('Ingredients') + '<ul class="pas-modal-list">' +
        String(p.ingredients).split('. ').map(function (t) { return t.trim(); }).filter(Boolean).map(function (t) {
          return '<li>' + escapeHtml(t.slice(-1) === '.' ? t : t + '.') + '</li>';
        }).join('') + '</ul>';
    }
    if (p.nutrition) {
      html += h2(category === 'Essential Oils' ? 'Key compounds' : 'Nutritional value (approx. per 100g)') + '<table class="pas-modal-table"><tbody>' +
        rows(p.nutrition).map(function (r) {
          var i = r.indexOf(': ');
          return '<tr><td>' + escapeHtml(i > -1 ? r.slice(0, i) : r) + '</td><td>' + escapeHtml(i > -1 ? r.slice(i + 2) : '') + '</td></tr>';
        }).join('') + '</tbody></table>';
    }
    if (p.tips) {
      html += h2('Preparation &amp; usage tips') + '<ul class="pas-modal-list">' +
        rows(p.tips).map(function (r) { return '<li>' + escapeHtml(r) + '</li>'; }).join('') + '</ul>';
    }
    html += '<div class="pas-modal-actions">' +
      '<a href="' + escapeHtml(p.url) + '" class="pas-modal-btn pas-modal-btn-solid">Open product page</a>' +
      '<button type="button" class="pas-modal-btn" data-close>Close</button></div>';

    var overlay = document.createElement('div');
    overlay.className = 'pas-modal';
    overlay.innerHTML = '<div class="pas-modal-card" role="dialog" aria-modal="true" aria-labelledby="pas-modal-title" tabindex="-1">' +
      '<button type="button" class="pas-modal-close" aria-label="Close">' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg></button>' +
      html + '</div>';
    document.body.appendChild(overlay);
    var prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    var card = $('.pas-modal-card', overlay);
    card.focus();

    function close() {
      document.removeEventListener('keydown', onKey);
      overlay.remove();
      document.body.style.overflow = prevOverflow;
      if (trigger && trigger.focus) trigger.focus();
    }
    function onKey(e) { if (e.key === 'Escape') close(); }
    document.addEventListener('keydown', onKey);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.closest('.pas-modal-close, [data-close]')) close();
    });
  }

  /* ------------------------------------------------------------ contact form */
  function initContact(root) {
    var form = $('[data-contact-form]', root);
    if (!form || form.dataset.ready) return;
    form.dataset.ready = '1';
    var reasonSel = $('[name="contact[Reason]"]', form);
    var catSel = $('[name="contact[Category]"]', form);
    var prodSel = $('[name="contact[Product]"]', form);
    var info = $('[data-product-info]', form);
    var dataEl = $('[data-contact-products]', form);
    var catalogue = dataEl ? JSON.parse(dataEl.textContent) : {};
    var params = new URLSearchParams(window.location.search);
    [catSel, prodSel].forEach(function (s) { if (s) enhanceSelect(s); });
    var refreshSelects = function () {
      [catSel, prodSel].forEach(function (s) { if (s && s._pasRefresh) s._pasRefresh(); });
    };

    var groupFor = function (reason) {
      if (reason === 'Wholesale & Export Inquiry') return 'wholesale';
      if (reason === 'Product Information') return 'product';
      return 'general';
    };
    function applyReason() {
      var g = groupFor(reasonSel.value);
      $$('[data-show-for]', form).forEach(function (w) {
        var show = w.dataset.showFor.split(' ').indexOf(g) > -1;
        w.toggleAttribute('hidden', !show);
        $$('input,select,textarea', w).forEach(function (c) {
          c.disabled = !show;
          var reqFor = (c.dataset.requiredFor || '').split(' ');
          c.required = show && reqFor.indexOf(g) > -1;
        });
        var opt = $('[data-optional-for]', w);
        if (opt) opt.textContent = opt.dataset.optionalFor.split(' ').indexOf(g) > -1 ? ' (Optional)' : '';
      });
      renderInfo();
    }
    function fillProducts(selected) {
      if (!prodSel) return;
      var list = (catSel && catalogue[catSel.value]) || [];
      prodSel.innerHTML = '';
      var first = document.createElement('option');
      first.value = '';
      first.textContent = list.length ? 'Select a product' : (catSel && catSel.value ? 'Not listed — describe it in your message' : 'Select a category first');
      prodSel.appendChild(first);
      list.forEach(function (p) {
        var o = document.createElement('option');
        o.value = p.title; o.textContent = p.title;
        if (p.image) o.dataset.image = p.image;
        if (p.title === selected) o.selected = true;
        prodSel.appendChild(o);
      });
      prodSel.disabled = list.length === 0;
      renderInfo();
    }
    function renderInfo() {
      refreshSelects();
      if (!info) return;
      var g = groupFor(reasonSel.value);
      var list = (catSel && catalogue[catSel.value]) || [];
      var p = list.filter(function (x) { return x.title === (prodSel && prodSel.value); })[0];
      if (!p || g === 'general') { info.setAttribute('hidden', ''); info.innerHTML = ''; return; }
      info.removeAttribute('hidden');
      currentProduct = p;
      info.innerHTML = '<button type="button" data-open-info aria-haspopup="dialog" class="flex gap-5 rounded-2xl bg-white/10 hover:bg-white/15 transition p-4 text-left w-full">' +
        (p.image ? '<img src="' + escapeHtml(p.image) + '" alt="" class="h-24 w-24 rounded-xl object-cover shrink-0">' : '') +
        '<span class="min-w-0 block"><span class="block text-[11px] uppercase tracking-[0.2em] text-white/55">' + escapeHtml(catSel.value) + '</span>' +
        '<span class="block font-display text-lg mt-0.5">' + escapeHtml(p.title) + '</span>' +
        '<span class="block mt-1 text-sm text-white/70 line-clamp-3" style="line-height:1.6">' + escapeHtml(p.note) + '</span>' +
        '<span class="block mt-2 text-sm text-accent-leaf">View full details →</span></span></button>';
    }
    var currentProduct = null;
    if (info) info.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-open-info]');
      if (trigger && currentProduct) openProductModal(currentProduct, catSel.value, trigger);
    });

    reasonSel.addEventListener('change', applyReason);
    if (catSel) catSel.addEventListener('change', function () { fillProducts(''); });
    if (prodSel) prodSel.addEventListener('change', renderInfo);

    // pre-fill from ?type= & ?product=
    var type = params.get('type');
    var product = params.get('product');
    if (type === 'wholesale' && !reasonSel.value) reasonSel.value = 'Wholesale & Export Inquiry';
    if (product) {
      Object.keys(catalogue).forEach(function (c) {
        catalogue[c].forEach(function (p) { if (p.title.toLowerCase() === product.toLowerCase() && catSel) catSel.value = c; });
      });
      if (!reasonSel.value) reasonSel.value = type === 'wholesale' ? 'Wholesale & Export Inquiry' : 'Product Information';
    }
    fillProducts(product || '');
    applyReason();

    form.addEventListener('submit', function () {
      var body = $('[name="contact[body]"]', form);
      if (body && !body.disabled && !body.value.trim()) body.value = 'Wholesale inquiry (no additional message).';
    });
  }

  /* ----------------------------------------------- collection / misc helpers */
  function initCollection(root) {
    $$('[data-sort-select]', root).forEach(function (sel) {
      if (sel.dataset.ready) return;
      sel.dataset.ready = '1';
      sel.addEventListener('change', function () {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', sel.value);
        u.searchParams.delete('page');
        window.location.href = u.toString();
      });
    });
    $$('[data-filter-form]', root).forEach(function (f) {
      if (f.dataset.ready) return;
      f.dataset.ready = '1';
      f.addEventListener('change', function () { f.submit(); });
    });
  }

  function initToggles(root) {
    $$('[data-toggle-target]', root).forEach(function (b) {
      if (b.dataset.ready) return;
      b.dataset.ready = '1';
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var t = document.getElementById(b.dataset.toggleTarget);
        if (!t) return;
        t.toggleAttribute('hidden');
        var other = b.dataset.toggleHide && document.getElementById(b.dataset.toggleHide);
        if (other) other.toggleAttribute('hidden');
      });
    });
  }

  function initAddressForms(root) {
    $$('[data-country-select]', root).forEach(function (country) {
      if (country.dataset.ready) return;
      country.dataset.ready = '1';
      var form = country.closest('form');
      var province = $('[data-province-select]', form);
      var wrap = $('[data-province-wrapper]', form);
      function sync(initial) {
        var opt = country.options[country.selectedIndex];
        var provinces = [];
        try { provinces = JSON.parse((opt && opt.dataset.provinces) || '[]'); } catch (e) {}
        var keep = province.dataset.default;
        province.innerHTML = '';
        provinces.forEach(function (p) {
          var o = document.createElement('option');
          o.value = p[0]; o.textContent = p[1];
          if (initial && keep && keep === p[0]) o.selected = true;
          province.appendChild(o);
        });
        wrap.toggleAttribute('hidden', provinces.length === 0);
      }
      country.addEventListener('change', function () { sync(false); });
      if (country.dataset.default) country.value = country.dataset.default;
      sync(true);
    });
  }

  /* -------------------------------------------------------------------- init */
  function init(root) {
    initSliders(root);
    initCarousels(root);
    initProduct(root);
    initContact(root);
    initCollection(root);
    initToggles(root);
    initAddressForms(root);
    initWishlistPage(root);
    initReveal(root);
    wlSync(root);
  }

  function boot() {
    initHeader();
    initCart();
    initPriceSheet();
    initWishlist();
    init(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  // Shopify theme editor: re-run when sections are added / edited
  document.addEventListener('shopify:section:load', function (e) { initHeader(); init(e.target); });
})();
